module.exports = __webpack_public_path__ + "media/images/bus/conditions/WC-eb005c1b0a44886d943a383f5d937b6f.svg";